import { render, staticRenderFns } from "./specialistCertificateList.vue?vue&type=template&id=953d62ca&"
import script from "./specialistCertificateList.vue?vue&type=script&lang=js&"
export * from "./specialistCertificateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports